import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';

import CustomDatepicker from '../components/Datepicker/CustomDatepicker';
import { SUPPLIER_DETAIL, CLIENTS_DETAIL, ELEVATOR, ELEVATOR_DETAIL } from '../constants/routes';
import { formatDate } from '../helpers/core';
import cn from "classnames";

class ClientsList extends Component {
	constructor (props) {
		super(props);

		this.state = {
			newCallsDate: new Date(),
			selected: []
		}
	}

	handleClientSelect = (e) => {
		const clientId = e.target.value;
		const selected = [...this.state.selected];
		const index = selected.indexOf(clientId);

		index !== -1 ? selected.splice(index, 1) : selected.push(clientId);

		this.setState({
			selected
		});
	}

	handlePageChange = (paginator) => {
		window.history.pushState(null, 'Список организаций', '#p_' + (paginator.selected + 1));
		this.props.onPaginatorChange(paginator);
	}

	handleSelectAllChange = (e) => {
		const checked = e.target.checked;
		const selected = checked ? this.props.list.map(client => client.id.toString()) : [];

		this.setState({ selected });
	}

	handleCallsDateChange = (date) => {
		this.setState({
			newCallsDate: date
		});
	}

	updateCallsDates = () => {
		const{ updateCallsDates, paginator, filter } = this.props;

		updateCallsDates({
			to_time: this.state.newCallsDate,
			client: this.state.selected,
			filter,
			pager: paginator
		});
	}

  hrefBuilder = (page_num) => `#p_${page_num}`;

	getDetailLink = (type, id) => {
		if(typeof type === 'undefined' || typeof id === 'undefined') return '#failed';
		switch(type.toString()) {
			case "1":
				return `${SUPPLIER_DETAIL}?id=${id}`;
			case "2":
				return `${CLIENTS_DETAIL}?id=${id}`;
			case "3":
				return `${ELEVATOR_DETAIL}?id=${id}`;
			default:
				throw new Error(`No such client type: ${type}`);
		}
	}

	render () {
		const { list, paginator, hideCallsButton } = this.props;

		return (
			<div>
				{
					!hideCallsButton ?
						<div className="action-panel mr-bottom-40 row">
							<div className="col-xs-2 mr-right-20">
								<CustomDatepicker
									selectedDay={this.state.newCallsDate}
									name="new_calls_date"
									onDayChange={this.handleCallsDateChange}
									disabledDays={[{before: new Date()}]}
								/>
							</div>
							<button className="col-xs-2 btn btn-warning mr-right-40" onClick={this.updateCallsDates}>
								Обновить дату звонка
							</button>

							<div className="pull-left">
								<span className="custom-form__label mr-right-20">Отметить всех</span>
								<input type="checkbox" name="check_all" onChange={this.handleSelectAllChange}/>
							</div>
						</div> : null
				}
				
				{
					list.length ?
						<table className="table table-bordered mr-bottom-40">
							<thead>
								<tr>
									<th>Номер</th>
									<th>Адрес</th>
									<th>Наименование</th>
									<th>Товар</th>
									<th>Звонили</th>
									<th>Позвонить</th>
									<th>НДС</th>
									<th>Без НДС</th>
									<th>Контакты</th>
									<th>Тема звонка</th>
									<th>Дополнительно</th>
									<th>А</th>
								</tr>
							</thead>
							<tbody className="small-font">
								{
									list.map((client) => {
										if(typeof client.id === 'undefined') return <tr key={Math.random()}><td colSpan="12"/></tr>;

										return <tr key={`client_${client.id}`}>
											<td>
												{client.id}.
												&nbsp;
												<input
													type="checkbox"
													onChange={this.handleClientSelect}
													value={client.id}
													checked={client.id ? this.state.selected.indexOf(client.id.toString()) !== -1 : false}
												/>
											</td>
											<td>
												Регион:<br/>
												{client.address}
											</td>
											<td>
												<Link to={this.getDetailLink(client.type, client.id)}><strong  className={cn("mr-bottom-20 btn-block", {
													"red-color": client.in_work
												})}>{client.name}</strong></Link>
												{client.categories ? client.categories.map((category, key) => <p key={`category_${key}`}>{category.label}</p>) : null}
											</td>
											<td>
												{client.cultures ? client.cultures.map((culture, key) => (
													<p key={`culture_${key}`}>
														{culture.name}
														{culture.price ? ` - ${culture.price}` : null}
														{culture.volume ? `- ${culture.volume}т.` : null}
														{culture.quality_comment ? <span className="qualiy-comment">{culture.quality_comment}</span> : null}
													</p>
												)) : null}
											</td>
											<td>{(client.date_called && client.date_called.length > 0) ? formatDate(client.date_called) : '-'}</td>
											<td>{(client.date_will_call && client.date_will_call.length > 0) ? formatDate(client.date_will_call) : '-'}</td>
											<td>{client.is_work_vat ? <i className="fi flaticon-checked"></i> : null}</td>
											<td>{client.is_work_no_vat ? <i className="fi flaticon-checked"></i> : null}</td>
											<td>
												{
													client.contacts ? client.contacts.map((contact, key) => (
														<p key={key}>{contact.phone}<br/>{contact.name}</p>
													)) : null
												}
											</td>
											<td>{client.call_aim}</td>
											<td>{client.additional_info}</td>
										</tr>
									})
								}
							</tbody>
						</table> :
						<p>Не найдено ни одной записи</p>
				}

				{
					list.length && paginator.total ?
						<ReactPaginate
							initialPage={paginator.page - 1}
							pageCount={Math.ceil(paginator.total / paginator.size)}
							previousLabel="Пред."
							nextLabel="След."
							containerClassName="paginator"
							onPageChange={this.handlePageChange}
							disableInitialCallback
							hrefBuilder={this.hrefBuilder}
						/> : null
				}
			</div>
		)
	}
}

ClientsList.propTypes = {
	updateCallsDates: PropTypes.func,
	list: PropTypes.array,
	paginator: PropTypes.object,
	filter: PropTypes.object,
	onPaginatorChange: PropTypes.func.isRequired,
	hideCallsButton: PropTypes.bool,
	type: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default ClientsList;



// WEBPACK FOOTER //
// ./components/ClientsList.js